// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"d4e75cea","787":"99d19b44"}[chunkId] + ".chunk.js";
};